import { METHOD_TYPES } from 'games/PredictionMarket/predictionMarket.constants'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import i18n from 'translation/index'
import { getLocalLanguage } from 'helpers/localstorage.helpers'

export const getCategoriesService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-categories', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMyPositionsService = (params) => {
  params = { ...params, lang: getLocalLanguage() || i18n.language }
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-my-positions', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMyOrdersService = (params) => {
  params = { ...params, lang: getLocalLanguage() || i18n.language }
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-my-orders', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getHistoryService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-history', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMarketActivityService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-market-activity', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMyProfitService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-my-profit', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMyMarketCommentsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-my-market-comment', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getTopHoldersService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-top-holders', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getTopPositionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-top-positions', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMarketCommentsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-market-comments', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMyOptionPositionService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-my-option-position', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMarketsService = (params) => {
  params = { ...params, lang: getLocalLanguage() || i18n.language }
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-markets', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getMarketDetailsService = (params) => {
  params = { ...params, lang: getLocalLanguage() || i18n.language }
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-question-details', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getOptionDetailsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-option-details', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getOptionGraphDataService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-option-graph-data', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const getOptionOrderbookService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-option-orderbook', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const placeOrderService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/place-order', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cancelLimitOrderService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/cancel-limit-order', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const depositService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/deposit', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const withdrawService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/withdraw', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const addCommentService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/add-comment', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const deleteCommentService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/delete-comment', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const likeToggleService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/like-toggle', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const toggleFavouriteQuestionService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'prediction-market/toggle-favourite-question', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getNewsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'prediction-market/get-news', params, {
    params,
    server: microServices.SERVICE_URL_1
  })
}